import styled from 'styled-components';

const Widget = styled.aside`
  margin-bottom: 30px;
`;

export const WidgetTitle = styled.h4`
  border-bottom: 1px solid ${p => p.theme.colors.border};
  margin: 0 0 10px 0;
  padding-bottom: 10px;
`;

export const WidgetContent = styled.div`
  margin: 0;
`;

export default Widget;
